import React, { useRef } from 'react'
import Slider from "react-slick";
// import Icons from "../../myIcon/Icons";
// import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default function RoomGallery({roomGallery}) {
    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
    };

    const CustomArrows = () => (
        <>
        <div className="roomgallery-arrow" onClick={() => sliderRef.current.slickNext()}>
            <img src="/image/longright-arrow.svg" alt="arrow" loading="lazy"/>
        </div>
        </>
    );
    

    // useEffect(() => {
    //     let fb;
    //     if (typeof window !== "undefined") {
    //         import("@fancyapps/ui").then((mod) => {
    //         fb = mod.Fancybox;
    //         fb.bind("[data-fancybox='gallery']", {});
    //         });
    //     }

    //     return () => {
    //         if (fb) {
    //         fb.destroy();
    //         }
    //     };
    // }, []);

  return (
    <>
    <section className="roomdetail-gallery">
        <div className="container">
            <div className="row justify-content-end">
                <div className="col-lg-11">
                    <div className="roomgallery-slider"> 
                        <Slider {...settings} ref={sliderRef}>
                            {roomGallery.map((item, index) => (
                                <img key={index} src={item.image} alt={`gallery-${index}`} className="img-responsive"/>

                                // <a href={item.image} data-fancybox="gallery" className='roomgallery-box' key={index}>
                                //     <img src={item.image} alt={`gallery-${index}`} className="img-responsive"/>
                                //     <Icons name="expand" />
                                // </a>
                            ))}
                        </Slider>
                        <CustomArrows />
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
